import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MarkdownService } from 'ngx-markdown';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  md: string = '';
  constructor(
    private http: HttpClient,
    private mdService: MarkdownService,
  ) { }

  ngOnInit(): void { 
    this.loadPrivacy();
  }

  async loadPrivacy() {
    this.http.get(`/assets/tos/privacy.md`,
      { responseType: 'text' }).subscribe({
        next: (res) => {
          this.md = this.mdService.compile(res);
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

}
